const store = {
  get: (value) => {
    // console.log('inside storage file: ', value, localStorage.getItem(value));
    if (localStorage.getItem('shouldUseSessionStorage') === 'true') {
      return sessionStorage.getItem(value) &&
        sessionStorage.getItem(value).toString().trim()[0] === '{'
        ? JSON.parse(sessionStorage.getItem(value))
        : value === 'companyId' && sessionStorage.getItem(value)
          ? parseInt(sessionStorage.getItem(value))
          : sessionStorage.getItem(value) === 'true' || sessionStorage.getItem(value) === 'false'
            ? JSON.parse(sessionStorage.getItem(value))
            : sessionStorage.getItem(value)
    }
    return localStorage.getItem(value) &&
      localStorage.getItem(value).toString().trim()[0] === '{'
      ? JSON.parse(localStorage.getItem(value))
      : value === 'companyId' && localStorage.getItem(value)
        ? parseInt(localStorage.getItem(value))
        : localStorage.getItem(value) === 'true' || localStorage.getItem(value) === 'false'
          ? JSON.parse(localStorage.getItem(value))
          : localStorage.getItem(value)
  },
  set: (key, value) => {
    // console.log('setting session storage: ', key, value);
    if (localStorage.getItem('shouldUseSessionStorage') === 'true') {
      typeof value === 'object'
        ? sessionStorage.setItem(key, JSON.stringify(value))
        : sessionStorage.setItem(key, value)
      return;
    }
    typeof value === 'object'
      ? localStorage.setItem(key, JSON.stringify(value))
      : localStorage.setItem(key, value)
  },
  remove: (value) => localStorage.getItem('shouldUseSessionStorage') === 'true'
    ? sessionStorage.removeItem(value)
    : localStorage.removeItem(value),
  clear: () => localStorage.getItem('shouldUseSessionStorage') === 'true'
    ? sessionStorage.clear()
    : localStorage.clear()
};

export default store;
